import { render, staticRenderFns } from "./AddEditFAQ.vue?vue&type=template&id=b407c68a"
import script from "./AddEditFAQ.vue?vue&type=script&lang=js"
export * from "./AddEditFAQ.vue?vue&type=script&lang=js"
import style0 from "./AddEditFAQ.vue?vue&type=style&index=0&id=b407c68a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports